import React from 'react';

export default React.createContext({
  cepNo: null,
  tc: null,
  step: null,
  token: null,

  setCepNo: (raw) => {},
  setTc: (raw) => {},
  setStep: (raw) => {},
  setToken: (raw) => {},

  fullname: '',
  slugify: (text) => text,
  removeTurkishChars: (text) => text,
  innerTexts: {},
});
